"use client";
import React, { useEffect, useRef } from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  animate,
  useInView,
} from "framer-motion";
import Tranform from "@/components/icons/tranform";
import MW from "@/components/icons/mw";
import DTR from "@/components/icons/dtr";
import HT from "@/components/icons/ht";
import ThreeDHome from "@/components/icons/three-d-home";
import Location2 from "@/components/icons/location2";
import Agriculture from "./icons/agriculture";
import Section from "./icons/section";

const AnimatedCounter = ({ target }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px" });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) =>
    Math.floor(latest).toLocaleString()
  );

  useEffect(() => {
    if (isInView) {
      const controls = animate(count, target, {
        duration: 1.8,
        ease: "easeOut",
      });
      return () => controls.stop();
    }
  }, [isInView, target]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
};
//
const stats = [
  { icon: <Location2 />, value: 1051, label: "Area (Sq. Kms)" },
  { icon: <MW />, value: 36, label: "33/11 KV SUB STATIONS" },
  { icon: <Tranform />, value: 179, label: "11KV FEEDERS" },
  { icon: <DTR />, value: 15644, label: "DTRS" },
  { icon: <Section />, value: 6, label: "NO. OF Sections" },
  { icon: <ThreeDHome />, value: 141296, label: "LT SERVICES" },
  {
    icon: <Agriculture />,
    value: 36699,
    label: "Agriculture Services",
  },
  { icon: <HT />, value: 619, label: "Industrial Services" },
];

const RescoCount = () => {
  return (
    <main className="bg-green-8 py-5 md:py-7 px-4 sm:px-6 lg:px-12 rounded-lg mt-2 md:mt-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {stats.map((item, index) => (
          <motion.div
            key={index}
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ type: "spring", stiffness: 100 }}
            whileHover={{ scale: 1.03 }}
            className="bg-white hover:bg-green-13 rounded-xl p-4 flex flex-row justify-between items-center gap-4 group cursor-pointer transition-colors duration-300 shadow-md shadow-gray-300 hover:shadow-green-400"
          >
            <div className="flex-1 text-left space-y-1">
              <div className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800">
                <AnimatedCounter target={item.value} />
              </div>
              <div className="text-sm sm:text-base font-semibold text-gray-700 uppercase">
                {item.label}
              </div>
              {item.date && (
                <div className="text-xs text-gray-600 italic">{item.date}</div>
              )}
            </div>

            <div className="w-14 h-14 sm:w-20 sm:h-20 p-2 rounded-lg flex items-center justify-center shrink-0 bg-[#007A722E] group-hover:bg-green-4 transition-transform duration-300 ease-in-out">
              <div className="w-10 h-10 sm:w-14 sm:h-14 flex justify-center items-center transform transition-transform duration-300 ease-in-out group-hover:rotate-12">
                {React.cloneElement(item.icon, { className: "w-full h-full" })}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </main>
  );
};

export default RescoCount;
